import { render, staticRenderFns } from "./BuefyTables.vue?vue&type=template&id=67d62d2f&"
import script from "./BuefyTables.vue?vue&type=script&lang=js&"
export * from "./BuefyTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports